import z from 'zod'
import { nullSafeOptionalFirestoreTimestamp } from '../shared/schema'

export const schema = z.object({
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  userId: z.string(),
})

export const empty = Object.freeze(
  schema.parse({
    updatedAt: { seconds: 0, nanoseconds: 0 },
    userId: '',
  })
)

export interface FirestoreUserProfileFavoriteCatalog extends z.infer<
  typeof schema
> {}
